import React from "react";
import ReactHtmlParser from "react-html-parser";
import { useSelector } from "react-redux";
import { Box, Container, Divider, LinearProgress, Typography } from "@mui/material";
import { Info } from "@mui/icons-material";
import { Toolbar } from "../toolbar/Toolbar";
import { Calculators } from "./Calculators";

export const Pages = () => {
	const view = useSelector(state => state.calculators.view);
	const calc = useSelector(state => state.calculators.schema).find((calc) => calc.path.slice(1) === view);
	const mixView = useSelector(state => state.channelMix.settings.view);
	const loadingStatus = useSelector(state => state.calculators.status);

	return (
		<>
			<Box sx={{pt: .5, position: "fixed", width: "100%", zIndex: "appBar", bgcolor: "background.paper"}}>
				<Box>
					<Container maxWidth="lg" sx={{maxWidth: "1600px !important", minWidth: "1600px !important"}}>
						<Toolbar />
					</Container>
					{loadingStatus === "loading" ? <LinearProgress /> : <Divider />}
				</Box>
			</Box>
			{(view !== "channel-mix" || (view === "channel-mix" && mixView !== "output")) &&
				<Box sx={{pt: "61px", bgcolor: "background.paper", color: "text.primary"}}>
					<Container maxWidth="lg" sx={{maxWidth: "1600px !important", minWidth: "1600px !important", p: 2, display: "flex", alignItems: "center"}}>
						<Info/>
						<Box>
							<Typography component={"div"} sx={{px: 2}}>
								<i>{ReactHtmlParser(calc.instructions)}</i>
							</Typography>
						</Box>
					</Container>
				</Box>
			}
			<Container maxWidth="lg" sx={{maxWidth: "1600px !important", minWidth: "1600px !important", minHeight: 500, pt: (view === "channel-mix" && mixView === "output") ? 8 : 0}}>
				<Calculators />
			</Container>
			{(!!calc.about && (view !== "channel-mix" || (view === "channel-mix" && mixView !== "output"))) &&
				<Box sx={{pb: 3, bgcolor: "background.paper", color: "text.primary"}}>
					<Container maxWidth="lg" sx={{maxWidth: "1600px !important", minWidth: "1600px !important", p: 2, display: "flex", alignItems: "center"}}>
						<Box>
							<Typography component={"div"} sx={{px: 2}}>
								<i>{ReactHtmlParser(calc.about)}</i>
							</Typography>
						</Box>
					</Container>
				</Box>
			}
		</>
	);
};